import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { TextField, type TextFieldProps } from './TextField.js';

export interface PasswordFieldProps extends Omit<TextFieldProps, 'type' | 'trailing' | 'mono'> {
  testoMostra?: string;
  testoNascondi?: string;
}

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(function PasswordField(
  { testoMostra = 'Mostra la password', testoNascondi = 'Nascondi la password', ...rest },
  ref,
) {
  const [visibile, setVisibile] = useState(false);
  const Icona = visibile ? EyeOff : Eye;
  return (
    <TextField
      ref={ref}
      type={visibile ? 'text' : 'password'}
      trailing={
        <button
          type="button"
          onClick={() => setVisibile((v) => !v)}
          aria-label={visibile ? testoNascondi : testoMostra}
          aria-pressed={visibile}
          className="h-11 w-11 inline-flex items-center justify-center rounded-md text-ink-muted hover:text-ink"
        >
          <Icona aria-hidden size={20} strokeWidth={1.75} />
        </button>
      }
      {...rest}
    />
  );
});
